import React, { useContext } from 'react';
import ContextApp from "../../../core/contexts/context.app";
import ServiceStorage from '../../../core/services/service.storage';
import { isMobile } from 'react-device-detect';
import ApiAuth from '../../../core/api/api.auth';
import { Link } from 'react-router-dom';
const Logout = () => {
  const ctx = useContext(ContextApp);

  if (ServiceStorage.getRefreshToken()) {
     ApiAuth.logout({ refreshToken: ServiceStorage.getRefreshToken() });
  }

  ctx.setIsAuth(false);
  //ServiceApi.logout();

  return (
    // <div className={`card card-custom`}>
    //   {/* Start Box Header */}
    //   <div className="card-header border-0 pt-5 mx-auto mb-5" >
    //     <Card style={{ width: '25rem' }} className="mx-auto text-center">
    //       <Card.Body>
    //         <Card.Title>با تشکر</Card.Title>
    //         <Card.Text>
    //           به امید دیدار مجدد شما
    //         </Card.Text>
    //         <Card.Text>
    //           <Card.Link href='/#/login'>
    //             جهت ورود به سامانه کلیک نمایید
    //           </Card.Link>
    //         </Card.Text>
    //         <Card.Text>
    //           <Card.Link href='/#/register'>
    //             جهت ثبت نام کلیک نمایید
    //           </Card.Link>
    //         </Card.Text>
    //       </Card.Body>
    //     </Card>
    //   </div>
    // </div >


    <div className='w-100 h-100  bg-white' style={{ overflow: "hidden" }} >
      <div> <img className='d-block mx-auto' style={{ width: isMobile ? "300px " : "400px", height: isMobile ? "300px " : "400px" }} src="/media/bg/goodbye.png" /></div>
      <div className='text-center'>
        <Link to='/login' className='btn btn-primary mb-5' style={{ borderRadius: "10px", width: isMobile ? "50% " : "20%" }}>
          ورود به حساب کاربری
        </Link>
      </div>
      <div className='text-center'>
        <Link to='/register' className=' btn btn-primary' style={{ borderRadius: "10px", width: isMobile ? "50% " : "20%" }}>
          ایجاد حساب کاربری
        </Link>
      </div>

    </div>

  );
}

export default Logout;
